import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { AuthenticationURLs } from "constants/in-app-urls";
import { useHostStore } from "host/HostStore";
import Cookies from "js-cookie";

const ProtectedRoute: React.FC<React.PropsWithChildren> = ({ children }) => {
    const { auth } = useHostStore();
    const [systemToken, setSystemToken] = useState(Cookies.get("system_token"));

    useEffect(() => {
        setSystemToken(Cookies.get("system_token"));
    }, [auth]);

    const redirectToAuth = (systemToken: any) => {
        if (!systemToken || systemToken === "") {
            const beforeAuthRedirectULR = window.location.href;
            const originURL = window.location.origin;
            const beforeUrl = new URL(beforeAuthRedirectULR);
            const emailIdParam = beforeUrl.searchParams.get("emailId");
            const sessionDomain = beforeUrl.searchParams.get("domain");
            if (emailIdParam) {
                localStorage.setItem("SessionEmailId", emailIdParam);
            }
            if (sessionDomain) {
                localStorage.setItem("SessionDomain", sessionDomain);
            }
            if (
                beforeAuthRedirectULR !== `${originURL}/` &&
                beforeAuthRedirectULR !== `${originURL}/${AuthenticationURLs.CUSTOMER_ANALYTICS_AUTH_SIGN_UP_URL}` &&
                beforeAuthRedirectULR !== `${originURL}/${AuthenticationURLs.AUTH_SIGN_UP_VERIFICATION_URL}`
            ) {
                localStorage.setItem("SessionRedirectURL", beforeAuthRedirectULR);
            }
        }
        return <Navigate to={`/${AuthenticationURLs.CUSTOMER_ANALYTICS_AUTH_SIGN_UP_URL}`} />;
    };

    return systemToken ? children : redirectToAuth(systemToken);
};

export default ProtectedRoute;
